import React from 'react';
import ReactDOM, { hydrateRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// const root = ReactDOM.createRoot(document.getElementById('root'));
const initialData = window.__INITIAL_DATA__ || {};
const initialSeo = window.__INITIAL_SEO__ || {};
const initialGlobalSchema = window.__INITIAL_GLOBAL_SCHEMA__ || null;

hydrateRoot(
  document.getElementById("root"),
  <BrowserRouter>
    <HelmetProvider>
      <App initialData={initialData} initialSeo={initialSeo} initialGlobalSchema={initialGlobalSchema} />
    </HelmetProvider>
  </BrowserRouter>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
